export const LEGACY_LEFT_RAIL_MIN_VIEWPORT_WIDTH = 2030;
export const STICKY_EDGE_AD_MIN_VIEWPORT_WIDTH = 2080;
